export const FAMILY_TREE_RECEIVED = 'FAMILY_TREE_RECEIVED'
export const FAMILY_TREE_UNLOADED = 'FAMILY_TREE_UNLOADED'